// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"420":"f2c8791b","453":"88a317f6","455":"29754611","977":"18c709d9"}[chunkId] + ".chunk.js";
};